export default [
  {
    name: 'Documentos',
    icon: 'mdi-file-document',
    path: '/admin/documents',
    component: () => import(/* webpackChunkName: "admin-documents" */ './views/AdminDocuments'),
    meta: {
      admin: true,
      adminToolbar: false,
      adminDrawer: true,
      tooltip: null,
    },
  },
  {
    name: 'D. Oficiales',
    icon: 'mdi-file-check-outline',
    path: '/admin/oficial-documents',
    component: () => import(/* webpackChunkName: "admin-documents" */ './views/OficialDocuments'),
    meta: {
      admin: true,
      adminToolbar: false,
      adminDrawer: true,
      tooltip: null,
    },
  },
];
